import axios from "axios";

const api = axios.create({
  baseURL: "https://cms.techprojects.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

//  JOB Related API calls
export const getJobs = () => {
  return api.get("/jobs");
};

// Page Related API calls
export const getPagesBySlug = (slug) => {
  return api.get(`/pages/slug/${slug}`);
};

// client creation related API'S

export const getClients = () => {
  return api.get("/clients");
};

// case study related API'S
export const getCaseStudies = () => {
  return api.get("/case-studies");
};

export default api;
